import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../../../actions'
import Operations from '../../../../operations'
import Selectors from '../../../../selectors'
import dayjs from 'dayjs'
import _ from 'lodash'
import { isBrowser, isTablet } from 'react-device-detect'
import { postJSON } from '../../../../common/services/api'
import { find } from 'lodash'
import { colors, sizes } from '@lmc/common/constants'
import { getNominative } from '../../../../common/utils'
import { GlyphButton } from '../../../../LEGACY/elemental'
import AnimateHeight from 'react-animate-height'
import {
  CarePlansPaywall,
  HelpLink,
  ListItem,
  Spinner,
} from '../../../../components/generic'
import { CarePlanNextReviewDate } from '../../../../components/carePlans'
import { CarePlanSortType } from './components'
import {
  ButtonOLD,
  EmptyState,
  NoDataIcon,
  NotStartedIcon,
  PageHeader,
} from '@lmc/ui-kit'
import Glyph from '../../../../LEGACY/Glyph'
import PdfExport from '../../../../components/pdf/PdfExport'

import { withRouter } from '../../../../withRouter'
import { history } from '../../../../store'

import CarePlansPopup from '../../../../components/carePlans/CarePlansPopup'
import { ProTag } from 'components/ProTag'

export class ResidentCarePlansDashboardScreen extends React.Component {
  state = { isClicked: false }

  handleClick = () => {
    this.setState((prevState) => ({
      isClicked: !prevState.isClicked,
    }))
    if (this.props.onClick) this.props.onClick()
  }

  getHasCarePlansEnabled = () => {
    const { features } = this.props

    return (
      features &&
      features.features?.carePlans?.enabled &&
      features.features?.pro?.enabled
    )
  }

  componentDidMount() {
    const {
      router: {
        params: { id },
      },
    } = this.props
    if (this.getHasCarePlansEnabled() && id) {
      this.fetchCarePlan(id)
      this.props.setSortType('a-z')
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      router: {
        params: { id },
      },
    } = this.props
    if (this.getHasCarePlansEnabled() && id !== nextProps.router.params.id) {
      this.fetchCarePlan(nextProps.router.params.id)
    }
  }

  createCarePlan = ({ carePlanAdl, resident }) => {
    postJSON({
      url: 'list/care-plans',
      method: 'POST',
      json: { carePlanAdl, resident },
    })
      .then((res) => {
        const carePlan = res.result
        this.redirectToCarePlan(carePlan)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  fetchCarePlan = (id) => {
    const { fetchCarePlan } = this.props
    if (this.getHasCarePlansEnabled()) {
      fetchCarePlan(id)
    }
  }

  getSubLabel = (carePlan, carers) => {
    if (!carePlan || !carePlan.editedOn) return 'No reviews yet'

    const carer = carePlan.editedBy && find(carers, { id: carePlan.editedBy })
    const date = dayjs(carePlan.editedOn).format('DD-MM-YYYY • HH:mm')

    const prefix = carePlan.nextReviewDate ? 'Reviewed' : 'Created'
    if (!carer || !carer.name)
      return (
        <span>
          {prefix} {date}
        </span>
      )
    return (
      <span>
        {prefix} {date} • {`${carer.name.first} ${carer.name.last}`}
      </span>
    )
  }

  handleSelect = (adl) => {
    if (!adl.carePlan) {
      this.createCarePlan({
        carePlanAdl: adl.id,
        resident: this.props.router.params.id,
        onComplete: this.redirectToCarePlan,
      })
    } else {
      this.redirectToCarePlan(adl.carePlan)
    }
  }

  redirectToCarePlan = (carePlan) => {
    const {
      router: { params },
    } = this.props
    history.push(`/residents/${params.id}/care-plans/${carePlan.id}`)
  }

  addCustomAdl = () => {
    this.props.openNewCarePlanModal({
      resident: this.props.router.params.id,
    })
  }

  // Render functions

  renderHeader = (resident, title) => {
    const {
      router: { params },
      hasAccess,
    } = this.props

    const date = dayjs().format('DD-MM-YYYY')
    const pdfTitle = `${resident.name.first} ${
      resident.name.last
    }'s ${getNominative(this.props.carePlanNominative, 'Care Plan')} - ${date}`
    const pdfUrl = `/api/list/residents/${resident.id}/pdf/care-plan`
    const addCarePlanDisabled =
      resident.status === 'pre-assessment' || resident.isActiveInitialAssessment

    const hasRolePermission = hasAccess(
      ['carehome-admin', 'senior-carer'],
      [
        {
          i: 'create',
          this: 'CarePlan',
        },
      ],
    )

    return (
      <PageHeader
        title={title}
        sticky
        onBack={
          !isDesktop
            ? () => history.replace?.(`/residents/${params.id}/profile`)
            : undefined
        }
      >
        <ProTag />
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ paddingRight: 8 }}>
            <PdfExport
              pdfTitle={pdfTitle}
              url={pdfUrl}
              text={isDesktop ? 'Download PDF' : 'PDF'}
            />
          </div>
          <div>
            <ButtonOLD
              type="primary"
              dataTestId="add-cp"
              onClick={this.addCustomAdl}
              icon={<Glyph name="plus" />}
              disabled={addCarePlanDisabled}
              disabledByPermission={!hasRolePermission}
            >
              {`Add ${getNominative(
                this.props.carePlanNominative,
                'Care Plan',
              )}`}
            </ButtonOLD>
          </div>
        </div>
      </PageHeader>
    )
  }

  renderAdl = (adl, carers, index) => {
    const customName = adl.carePlan && adl.carePlan.customName

    const showCarePlanRiskAssessmentsPopup =
      adl?.carePlan?.riskAssessments?.length

    const { hasAccess } = this.props

    const hasRolePermission = hasAccess(
      ['carehome-admin', 'senior-carer'],
      [
        {
          i: 'view',
          this: 'CarePlan',
        },
      ],
    )

    return (
      <ListItem
        dataTestId="care-plans"
        icon={adl.icon}
        iconColor={adl.color}
        key={adl.id || index}
        label={customName || adl.name}
        onSelect={() => {
          if (!hasRolePermission) {
            return
          }
          this.handleSelect(adl)
        }}
        subLabel={this.getSubLabel(adl.carePlan, carers)}
        multiSelect
        subLabelChildren={
          showCarePlanRiskAssessmentsPopup ? (
            <CarePlansPopup
              carePlanRiskAssessments={adl.carePlan?.riskAssessments}
            />
          ) : null
        }
      >
        <CarePlanNextReviewDate
          date={adl.carePlan ? adl.carePlan.nextReviewDate : null}
          noFurtherSupportRequired={
            adl.carePlan?.noFurtherSupportRequired ?? false
          }
          alert={adl.alert}
          style={{
            ...styles.adlReviewDate,
            alignSelf: 'center',
          }}
        />
      </ListItem>
    )
  }

  renderAdls = (adls, carers) => {
    if (!adls) return <Spinner />
    const currentAdls = _.filter(
      adls,
      (d) => !(d.carePlan && d.carePlan.noFurtherSupportRequired),
    )
    const archivedAdls = _.filter(
      adls,
      (d) => d.carePlan && d.carePlan.noFurtherSupportRequired,
    )
    return (
      <div data-cy="cp-list">
        {isDesktop && this.renderSortType()}
        <h3 style={styles.adlSectionHeader}>Current</h3>
        {currentAdls.map((adl, index) => this.renderAdl(adl, carers, index))}
        <h3
          style={{
            ...styles.subTitle,
            paddingBottom: archivedAdls.length ? 0 : 10,
          }}
          onClick={() => this.handleClick()}
        >
          No Further Support Required
          {!!archivedAdls.length && (
            <GlyphButton
              className="lmc-collapse-button"
              glyph={this.state.isClicked ? 'chevron-up' : 'chevron-down'}
              style={styles.glyph}
              glyphSize="medium"
            />
          )}
        </h3>
        <AnimateHeight
          duration={500}
          height={this.state.isClicked ? 'auto' : 0}
          animateOpacity
        >
          {archivedAdls.map((adl, index) => this.renderAdl(adl, carers, index))}
        </AnimateHeight>
        {!archivedAdls.length && (
          <EmptyState
            icon={<NoDataIcon />}
            title="Nothing to see here!"
            description={getRenderAdlsBlankState(this.props.carePlanNominative)}
          >
            <a
              href={NO_IDENTIFIED_NEED_ARTICLE}
              rel="noreferrer"
              target="_blank"
            >
              Find out more
            </a>
          </EmptyState>
        )}
        <div style={styles.linksContainer}>
          <div style={{ 'align-self': 'flex-end' }}>
            <HelpLink supportLink={SUPPORT_LINK} style={styles.supportLink} />
          </div>
        </div>
      </div>
    )
  }

  renderSortType = () => {
    const { setSortType, sortType } = this.props
    return (
      <div style={styles.sortContainer}>
        <span style={styles.sortBy}>Sort by:</span>
        <div style={styles.sort}>
          <CarePlanSortType onChange={setSortType} sortType={sortType} />
        </div>
      </div>
    )
  }

  renderInitialAssessmentInfo = (resident) => (
    <div>
      <EmptyState
        icon={<NotStartedIcon />}
        title={`Finalise ${
          resident.name.first
        }'s Initial Assessment to generate a ${getNominative(
          this.props.carePlanNominative,
          'Care Plan',
        )}`}
        description={`When you finalise the Initial Assessment for this ${getNominative(
          this.props.preferredPeopleNominative,
          'resident',
        )}, you’ll be able to create their ${getNominative(
          this.props.carePlanNominative,
          'Care Plan',
        )}.`}
      />
      <HelpLink supportLink={PRE_ASSESSMENT_ARTICLE} />
    </div>
  )

  render() {
    const {
      carers,
      router: {
        params: { id },
      },
      adls,
      residents,
    } = this.props

    const resident = find(residents, { id })
    if (!resident || !this.getHasCarePlansEnabled()) {
      return <CarePlansPaywall />
    }
    if (!id || !resident) return <Spinner />

    const isInitialAssessment =
      resident.status === 'pre-assessment' || resident.isActiveInitialAssessment
    const title = `${resident.name.first || ''} ${
      resident.name.last || ''
    }'s ${getNominative(this.props.carePlanNominative, 'Care Plan')}`
    return (
      <div style={styles.wrapper}>
        {this.renderHeader(resident, title)}
        {isInitialAssessment
          ? this.renderInitialAssessmentInfo(resident)
          : this.renderAdls(adls, carers)}
      </div>
    )
  }
}

const getRenderAdlsBlankState = (carePlanNominative) =>
  `${getNominative(
    carePlanNominative,
    'Care Plans',
  )} will appear here if they have been reviewed as having ‘No Further Support Required’.`

const SUPPORT_LINK =
  'https://support.logmycare.co.uk/en/collections/3459514-care-plans'
const NO_IDENTIFIED_NEED_ARTICLE =
  'https://support.logmycare.co.uk/en/articles/3362768-how-does-no-further-support-required-work'
const PRE_ASSESSMENT_ARTICLE =
  'https://support.logmycare.co.uk/en/articles/3376601-how-do-i-finalise-a-initial-assessment'

const isDesktop = isBrowser || isTablet

const styles = {
  addAdlButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 20,
  },
  glyph: {},
  adlReviewDate: {
    paddingRight: 5,
  },
  adlSectionHeader: {
    paddingBottom: 10,
    marginBottom: 2,
    paddingLeft: 5,
  },
  divider: {
    height: 2,
    marginBottom: 12,
    marginTop: 8,
    width: '100%',
  },
  linksContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  sort: {
    position: 'relative',
    top: 2,
  },
  sortBy: {
    color: colors.darkgrey,
    display: 'block',
    marginRight: 12,
  },
  sortContainer: {
    alignItems: 'flex-end',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 12,
    // TODO: the sortContainer should be moved inside the "current" collapsible container
    position: 'relative',
    top: 28,
  },
  subTitle: {
    marginTop: 30,
    marginBottom: 2,
    paddingLeft: 5,
    borderBottom: `1px solid ${colors.grey}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  supportLink: {
    display: 'inline-block',
    float: 'left',
    marginTop: 0,
  },
  title: {
    marginBottom: 0,
  },
  wrapper: {
    padding: '0px 0px 50px',
    margin: '0 auto',
    maxWidth: sizes.childScreen,
  },
}

ResidentCarePlansDashboardScreen.propTypes = {
  carers: PropTypes.array,
  features: PropTypes.object,
  fetchCarePlan: PropTypes.func.isRequired,
  residentAdls: PropTypes.object,
  carePlanNominative: PropTypes.string,
}

const mapStateToProps = (state) => ({
  carers: state.data.carers,
  adls: Selectors.sortAdls(state),
  features: state.global.home,
  residents: state.data.residents,
  sortType: state.carePlans.carePlanSortType,
  carePlanNominative: state.global.home.preferredCarePlansNominative,
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  hasAccess: (roles, abilities) =>
    Selectors.checkRoleAccess(state, { roles, abilities }),
})

const mapDispatchToProps = (dispatch) => ({
  openNewCarePlanModal: ({ resident }) => {
    dispatch(
      Actions.openModal({
        modalId: 'addCarePlan',
        data: { resident },
      }),
    )
    dispatch(Actions.addForm({ formId: 'addCarePlan' }))
  },
  fetchCarePlan: (id) => dispatch(Operations.fetchResidentAdls(id)),
  setSortType: (type) => dispatch(Actions.setCarePlanSortType(type)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ResidentCarePlansDashboardScreen))
